import React, {createContext} from 'react';
import {useCanGoBack_PRIVATE} from './useCanGoBack';

const CanGoBackContext = createContext<boolean>(false);

export const CanGoBackProvider = ({children}: {children: React.ReactNode}) => {
  // eslint-disable-next-line no-restricted-syntax
  const historyBackPossible = useCanGoBack_PRIVATE();

  return (
    <CanGoBackContext.Provider value={historyBackPossible}>
      {children}
    </CanGoBackContext.Provider>
  );
};

export const useCanGoBack = () => React.useContext(CanGoBackContext);
